import { VillaSearchSummaryContent } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary-content/villa-search-summary-content";
import { useVillaSearchSummary } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.hook";
import { VillaSearchSummaryPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<VillaSearchSummaryPropertiesType> = (properties) => {
  const viewProperties = useVillaSearchSummary(properties);
  return <VillaSearchSummaryContent {...viewProperties} />;
};

export const VillaSearchSummary = memo(Component, deepCompare);
